import { render, staticRenderFns } from "./FattureUscita.vue?vue&type=template&id=e4faac7e"
import script from "./FattureUscita.vue?vue&type=script&lang=js"
export * from "./FattureUscita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports